// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsAppButton_root__3kWQW"};